import { Platform, StyleSheet } from "react-native";
import { Theme } from "../theme-provider";

const filtersStyle = (theme: Theme) => {
    const isWeb = Platform.OS === 'web';

    return StyleSheet.create({
    container: {
        flexDirection: 'column',
        alignItems: 'stretch',
    },

    crop: {
        overflow: 'hidden',
    },

    filterOptions: {
        position: 'absolute',
        width: '100%',
        flexDirection: 'row',
        flexWrap: 'wrap',
        backgroundColor: theme.color.listBackgroundInverted,
        padding: theme.spacing.standard,
        paddingLeft: theme.spacing.sides,
        paddingRight: theme.spacing.sides,
        borderBottomLeftRadius: isWeb ? theme.borderRadius.standard : 0,
        borderBottomRightRadius: isWeb ? theme.borderRadius.standard : 0,
    },

    filterOption: {
        flexDirection: 'row',
        alignItems: 'center',
        width: '50%',
    },

    fullWidth: {
        width: '100%',
    },

    filterOptionText: {
        color: theme.color.textInverted,
    },

    filterOptionIcon: {
        width: theme.iconSize.medium,
        height: theme.iconSize.medium,
        marginRight: theme.spacing.half,
    },

    filterDropdowns: {
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: isWeb ? theme.color.listBackground : theme.color.listEntryBackground,
        paddingLeft: theme.spacing.sides,
        paddingRight: theme.spacing.sides,
        borderTopWidth: isWeb ? 1 : 0,
        borderBottomWidth: isWeb ? 1 : 0,
        borderColor: isWeb ? theme.color.textSecondary : 'transparent',
    },

    filterDropdown: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingTop: isWeb ? theme.spacing.half + theme.spacing.sliver : theme.spacing.half,
        paddingBottom: isWeb ? theme.spacing.half + theme.spacing.sliver : theme.spacing.half,
        paddingRight: theme.spacing.standard,
    },

    filterDropdownText: {
        color: isWeb ? theme.color.textPrimary : theme.color.textSecondary,
        fontSize: isWeb ? theme.fontSize.small : undefined,
    },

    dropdownIconContainer: {
        marginLeft: theme.spacing.sliver,
        marginTop: theme.spacing.sliver,
    },

    dropdownIconContainerActive: {
        transform: [{ scaleY: -1 }],
    },

    filterDropdownIcon: {
        color: isWeb ? theme.color.textPrimary : theme.color.textSecondary,
        width: theme.iconSize.extraSmall,
        height: theme.iconSize.extraSmall,
    },
});
};

export { filtersStyle };